import { combineReducers } from 'redux';
import requestOtp from './requestOtp'
import updatePassword from './updatePassword'
import verifyOtp from './verifyOtp'

export default combineReducers({
    requestOtp,
    updatePassword,
    verifyOtp,
});